import * as React from "react";
const SvgBookOpen = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...props },
    React.createElement("path", { fill: "currentColor", d: "M13 20v2h-2v-2H2V4h7a4 4 0 0 1 3 1.354A4 4 0 0 1 15 4h7v16zm7-2V6h-5a2 2 0 0 0-2 2v10zm-9 0V8a2 2 0 0 0-2-2H4v12z" })));
export default SvgBookOpen;
//# sourceMappingURL=BookOpen.js.map